import { PlayerType } from './hooks/usePlayer';
import { StageType } from './types';
import { logMessage } from './utils/logger';

export const STAGE_WIDTH = 12;
export const STAGE_HEIGHT = 20;

export const createStage = (): StageType => 
  Array.from(Array(STAGE_HEIGHT), () => 
    new Array(STAGE_WIDTH).fill([0, 'clear']) as [string | number, string][]
  );

export const checkCollision = (
  player: PlayerType,
  stage: StageType,
  { x: moveX, y: moveY }: { x: number; y: number }
): boolean => {
  // Add a safety check for null or undefined player or tetromino
  if (!player || !player.tetromino) {
    return false;
  }
  
  for (let y = 0; y < player.tetromino.length; y += 1) {
    for (let x = 0; x < player.tetromino[y].length; x += 1) {
      // 1. Check that we're on an actual Tetromino cell
      if (player.tetromino[y][x] !== 0) {
        const newY = y + player.pos.y + moveY;
        const newX = x + player.pos.x + moveX;
        
        // 2. Check that our move is inside the game areas height (y)
        // We shouldn't go through the bottom of the play area
        if (newY >= stage.length) {
          logMessage("Collision detected: Out of bounds (height) newY=" + newY + ", stage.length=" + stage.length);
          return true;
        }
        
        // 3. Check that our move is inside the game areas width (x)
        if (newX < 0 || newX >= stage[0].length) {
          logMessage("Collision detected: Out of bounds (width) newX=" + newX + ", stage[0].length=" + stage[0].length);
          return true;
        }
        
        // 4. Check that the cell we're moving to isn't set to clear
        // Skip collision check for cells above the top of the stage
        if (newY >= 0 && stage[newY][newX][1] !== 'clear') {
          logMessage("Collision detected: Cell not clear newX=" + newX + ", newY=" + newY + ", stage[newY][newX][1]=" + stage[newY][newX][1]);
          return true;
        }
      }
    }
  }
  return false;
};
